module.exports = __webpack_public_path__ + "img/primary_3x3_z16.03b41eed.svg";